import * as Mod1 from "./discourse/admin-discourse-topic-from-form-route-map";
import * as Mod2 from "./discourse/components/dtff/field-editor";
import * as Mod3 from "./discourse/components/dtff/field-input";
import * as Mod4 from "./discourse/components/dtff/form-editor";
import * as Mod5 from "./discourse/components/dtff/form-preview";
import * as Mod6 from "./discourse/components/dtff/forms-index";
import * as Mod7 from "./discourse/components/dtff/public-form";
import * as Mod8 from "./discourse/components/dtff/tag-rules-editor";
import * as Mod9 from "./discourse/components/dtff/template-editor";
import * as Mod10 from "./discourse/connectors/category-custom-settings/dtff-required-form.gjs";
import * as Mod11 from "./discourse/discourse-topic-from-form-route-map";
import * as Mod12 from "./discourse/initializers/dtff-admin-nav";
import * as Mod13 from "./discourse/initializers/dtff-composer-interception";
import * as Mod14 from "./discourse/routes/admin-plugins/show/forms/edit";
import * as Mod15 from "./discourse/routes/admin-plugins/show/forms/index";
import * as Mod16 from "./discourse/routes/admin-plugins/show/forms/new";
import * as Mod17 from "./discourse/routes/topic-from-form";
import * as Mod18 from "./discourse/templates/admin-plugins/show/forms/edit";
import * as Mod19 from "./discourse/templates/admin-plugins/show/forms/index";
import * as Mod20 from "./discourse/templates/admin-plugins/show/forms/new";
import * as Mod21 from "./discourse/templates/topic-from-form";
const compatModules = {
  "discourse/admin-discourse-topic-from-form-route-map": Mod1,
  "discourse/components/dtff/field-editor": Mod2,
  "discourse/components/dtff/field-input": Mod3,
  "discourse/components/dtff/form-editor": Mod4,
  "discourse/components/dtff/form-preview": Mod5,
  "discourse/components/dtff/forms-index": Mod6,
  "discourse/components/dtff/public-form": Mod7,
  "discourse/components/dtff/tag-rules-editor": Mod8,
  "discourse/components/dtff/template-editor": Mod9,
  "discourse/connectors/category-custom-settings/dtff-required-form": Mod10,
  "discourse/discourse-topic-from-form-route-map": Mod11,
  "discourse/initializers/dtff-admin-nav": Mod12,
  "discourse/initializers/dtff-composer-interception": Mod13,
  "discourse/routes/admin-plugins/show/forms/edit": Mod14,
  "discourse/routes/admin-plugins/show/forms/index": Mod15,
  "discourse/routes/admin-plugins/show/forms/new": Mod16,
  "discourse/routes/topic-from-form": Mod17,
  "discourse/templates/admin-plugins/show/forms/edit": Mod18,
  "discourse/templates/admin-plugins/show/forms/index": Mod19,
  "discourse/templates/admin-plugins/show/forms/new": Mod20,
  "discourse/templates/topic-from-form": Mod21,
};
export { compatModules };
export default compatModules;
